import { storage } from "@/api/firebase/firebase.config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

/**
 * Uploads an image file to a specified location in cloud storage and returns the download URL.
 *
 * @param file - The image file to be uploaded.
 * @param location - The storage location path where the file will be uploaded.
 * @returns A promise that resolves to the download URL of the uploaded image.
 * @throws Will throw an error if no file is provided or if the upload process fails.
 */

export const uploadImage = async (
  file: File,
  location: string
): Promise<string> => {
  if (!file) {
    throw new Error("No file provided for upload.");
  }

  const storageRef = ref(storage, `${location}/${file.name}`);

  try {
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);

    // Replace the firebase URL with ImageKit.io URL-endpoint
    const imageKitURL = downloadURL.replace(
      "https://firebasestorage.googleapis.com/v0/b/people-2e2dc.firebasestorage.app/o",
      "https://ik.imagekit.io/gmng/people"
    );

    return imageKitURL;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to upload image: ${error.message}`);
    } else {
      throw new Error("Failed to upload image due to an unknown error.");
    }
  }
};
